import type { Severity } from 'hooks/useAirspaceSummary/types';

export const TEST_ID = 'airspaceCardList';

export const MAX_VISIBLE_RESTRICTIONS = 10;

export const SEVERITY_ORDER: Record<Severity, number> = {
    advisory: 1,
    critical: 3,
    info: 0,
    prohibited: 4,
    safe: -1,
    warning: 2
};
